/* eslint-disable linebreak-style */
import React from 'react';
import PropTypes from 'prop-types';
import ContentLoader from 'react-content-loader';
import useDeviceScreen from 'root/hooks/useDeviceScreen';
import { useAmp } from 'next/amp';

const Loading = ({ mobile, desktop }) => {
  const { isMobile } = useDeviceScreen();
  const isAmp = useAmp();
  const width = (isAmp || isMobile) ? mobile.width : desktop.width;
  const height = (isAmp || isMobile) ? mobile.height : desktop.height;

  return !isMobile ? (
    <ContentLoader
      speed={9}
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      backgroundColor="#f3f3f3"
      foregroundColor="#ecebeb"
    >
      <rect x="17" y="20" rx="0" ry="0" width="130" height="135" />
      <rect x="171" y="18" rx="0" ry="0" width="275" height="21" />
      <rect x="500" y="18" rx="0" ry="0" width="20" height="21" />
      <rect x="530" y="18" rx="0" ry="0" width="20" height="21" />
      <rect x="560" y="18" rx="0" ry="0" width="20" height="21" />
      <rect x="170" y="60" rx="5" ry="5" width="415" height="15" />
      <rect x="170" y="80" rx="5" ry="5" width="415" height="15" />
      <rect x="170" y="80" rx="5" ry="5" width="415" height="15" />
      <rect x="170" y="100" rx="5" ry="5" width="415" height="15" />
      <rect x="170" y="120" rx="5" ry="5" width="415" height="15" />
      <rect x="170" y="140" rx="5" ry="5" width="415" height="15" />
      <rect x="17" y="160" rx="5" ry="5" width="570" height="15" />
      <rect x="17" y="180" rx="5" ry="5" width="570" height="15" />
      <rect x="17" y="200" rx="5" ry="5" width="570" height="15" />
      <rect x="200" y="240" rx="5" ry="5" width="200" height="75" />
    </ContentLoader>
  ) : (
    <ContentLoader
      speed={9}
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      backgroundColor="#f3f3f3"
      foregroundColor="#ecebeb"
    >
      <rect x="17" y="20" rx="0" ry="0" width="130" height="135" />
      <rect x="171" y="18" rx="0" ry="0" width="275" height="21" />
      <rect x="500" y="18" rx="0" ry="0" width="20" height="21" />
      <rect x="530" y="18" rx="0" ry="0" width="20" height="21" />
      <rect x="560" y="18" rx="0" ry="0" width="20" height="21" />
      <rect x="170" y="60" rx="5" ry="5" width="415" height="15" />
      <rect x="170" y="80" rx="5" ry="5" width="415" height="15" />
      <rect x="170" y="80" rx="5" ry="5" width="415" height="15" />
      <rect x="170" y="100" rx="5" ry="5" width="415" height="15" />
      <rect x="170" y="120" rx="5" ry="5" width="415" height="15" />
      <rect x="170" y="140" rx="5" ry="5" width="415" height="15" />
      <rect x="17" y="160" rx="5" ry="5" width="570" height="15" />
      <rect x="17" y="180" rx="5" ry="5" width="570" height="15" />
      <rect x="17" y="200" rx="5" ry="5" width="570" height="15" />
      <rect x="200" y="240" rx="5" ry="5" width="200" height="75" />
    </ContentLoader>
  );
};

Loading.propTypes = {
  mobile: PropTypes.object,
  desktop: PropTypes.object,
};

export default Loading;
